// add-unit.component.ts
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { BrandService } from 'app/services/brand/brand.service';
import { UnitService } from 'app/services/units/unit.service';

@Component({
  selector: 'app-add-unit',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './add-unit.component.html',
  styleUrls: ['./add-unit.component.scss']
})
export class AddUnitComponent implements OnInit {
  unitForm!: FormGroup;
  submitted = false;
  isLoading = false;
  loadingMessage = '';

 

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private unitService: UnitService
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  private initializeForm() {
    this.unitForm = this.fb.group({
      code: ['', [Validators.minLength(2), Validators.maxLength(10)]],
      type: [1],
      arName: ['', [Validators.required, Validators.minLength(2)]],
      enName: ['', [Validators.required, Validators.minLength(2)]]
    });
  }

  // الدوال المساعدة للوصول إلى عناصر الفورم
  get f(): { [key: string]: AbstractControl } {
    return this.unitForm.controls;
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.unitForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  getFieldError(fieldName: string): string {
    const field = this.unitForm.get(fieldName);
    if (field?.errors) {
      if (field.errors['required']) {
        return 'هذا الحقل مطلوب';
      }
      if (field.errors['minlength']) {
        return `الحد الأدنى للحروف هو ${field.errors['minlength'].requiredLength}`;
      }
      if (field.errors['maxlength']) {
        return `الحد الأقصى للحروف هو ${field.errors['maxlength'].requiredLength}`;
      }
      if (field.errors['min']) {
        return `القيمة يجب أن تكون ${field.errors['min'].min} أو أكثر`;
      }
    }
    return '';
  }

  // إنشاء الوحدة
  onSubmit(): void {
    this.submitted = true;

    if (!this.unitForm.valid) {
      this.markFormGroupTouched(this.unitForm);
      alert('❌ يوجد أخطاء في النموذج. راجع الحقول المطلوبة.');
      return;
    }

    this.createUnit();
  }

private createUnit(): void {
  this.isLoading = true;
  this.loadingMessage = 'جاري إنشاء الوحدة...';

  const unitData = this.prepareUnitData();

  this.unitService.createUnit(unitData).subscribe({
    next: (response) => {
      this.isLoading = false;

      if (response.success) {
        alert('✅ تم إنشاء الوحدة بنجاح!');
        this.router.navigate(['/admin/units']);
      } else {
        alert('❌ حدث خطأ أثناء إنشاء الوحدة');
      }
    },
    error: (error: HttpErrorResponse) => {
      this.isLoading = false;
      this.handleError(error);
    }
  });

  // احذف السطر ده
  // this.isLoading = false;
}

private prepareUnitData(): any {
  const formValue = this.unitForm.value;

  return {
    code: formValue.code?.trim() || '',
    type: Number(formValue.type),
    ar_name: formValue.arName.trim(),
    en_name: formValue.enName.trim()
  };
}

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control?.markAsTouched();
      }
    });
  }

  private handleError(error: HttpErrorResponse): void {
    let errorMessage = '❌ حدث خطأ أثناء إنشاء الوحدة';
    
    if (error.error && error.error.errors) {
      // معالجة أخطاء التحقق من الصحة من الخادم
      const validationErrors = error.error.errors;
      const errorMessages = [];
      
      for (const field in validationErrors) {
        if (validationErrors.hasOwnProperty(field)) {
          errorMessages.push(...validationErrors[field]);
        }
      }
      
      if (errorMessages.length > 0) {
        errorMessage = '❌ ' + errorMessages.join('\n');
      }
    } else if (error.error && error.error.message) {
      errorMessage = '❌ ' + error.error.message;
    }
    
    alert(errorMessage);
  }

  onReset(): void {
    if (confirm('هل تريد إعادة تعيين النموذج؟ سيتم فقدان جميع البيانات.')) {
      this.unitForm.reset({
        code: '',
        type: 1,
        arName: '',
        enName: ''
      });
      this.submitted = false;
    }
  }

  onCancel(): void {
    if (confirm('هل تريد إلغاء التغييرات؟')) {
      this.router.navigate(['/admin/units']);
    }
  }

  // دالة مساعدة لإنشاء كود تلقائي
  generateCode(): void {
    const name = this.unitForm.get('enName')?.value;
    if (name && name.length >= 2) {
      const code = name.substring(0, 3).toUpperCase();
      this.unitForm.patchValue({ code });
    }
  }
}